var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#3779E1",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15489 10.0344C4.95259 10.2402 4.94175 10.6194 5.16212 10.8361C5.38248 11.0564 5.75819 11.0492 5.9641 10.8433L8.00158 8.80647L10.0354 10.8397C10.2486 11.0564 10.6171 11.0528 10.8338 10.8325C11.0542 10.6158 11.0542 10.2474 10.841 10.0344L8.80717 8.00112L10.841 5.96427C11.0542 5.75119 11.0542 5.38282 10.8338 5.16614C10.6171 4.94584 10.2486 4.94584 10.0354 5.15891L8.00158 7.19216L5.9641 5.1553C5.75819 4.95306 5.37887 4.94223 5.16212 5.16253C4.94536 5.38282 4.95259 5.75841 5.15489 5.96427L7.19237 8.00112L5.15489 10.0344Z",
    fill: "#2E3A59",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.285b834a4640464f1f3f168cafb684f5.svg";
export { ForwardRef as ReactComponent };